import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlockingComponent } from '@symmetry/md-lib';

@Component({
  selector: 'sym-blocking-loader',
  templateUrl: './blocking-loader.component.html',
  styleUrls: ['./blocking-loader.component.scss']
})
export class BlockingLoaderComponent implements OnInit {
  public mode = 'indeterminate';
  public color = 'primary';
  public message = 'loading';
  public value = 0;
  constructor(
    public dialogRef: MatDialogRef<BlockingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data) {
      if (this.data.message) {
        this.message = this.data.message;
      }
      if (this.data.color) {
        this.color = this.data.color;
      }
      if (this.data.mode) {
        this.mode = this.data.mode;
      }
    }
  }

}
